var Platform;
(function (Platform) {
    var SearchPage;
    (function (SearchPage) {
        function addEntry(control, form, type, entityId, formGroupId, parameters) {
            if (type === void 0) { type = "Dialog"; }
            if (entityId === void 0) { entityId = null; }
            entityId = entityId || form.control(control).getEntityId();
            if (type === "Dialog") {
                Agitavit.Utilities.openQuickEditDialog(entityId, null, null, null, function () {
                    form.control(control).reloadData();
                }, formGroupId, parameters);
            }
            else {
                Agitavit.Utilities.openBrowserTab(window.location.protocol + "//" + window.location.host + window.location.pathname + "/Default" + window.location.search);
            }
        }
        SearchPage.addEntry = addEntry;
        function editEntry(control, form, type, entityId, formGroupId, parameters) {
            if (type === void 0) { type = "Dialog"; }
            if (entityId === void 0) { entityId = null; }
            entityId = entityId || form.control(control).getEntityId();
            var selectedRows = form.control(control).getSelectedRows();
            if (selectedRows.length !== 1) {
                return;
            }
            if (type === "Dialog") {
                Agitavit.Utilities.openQuickEditDialog(entityId, selectedRows[0], null, null, function () {
                    form.control(control).reloadData();
                }, formGroupId, parameters);
            }
            else {
                Agitavit.Utilities.openBrowserTab(window.location.protocol + "//" + window.location.host + window.location.pathname + "/Default/" + selectedRows[0] + window.location.search);
            }
        }
        SearchPage.editEntry = editEntry;
        function removeEntries(control, form, entityId) {
            if (entityId === void 0) { entityId = null; }
            entityId = entityId || form.control(control).getEntityId();
            var selectedRows = form.control(control).getSelectedRows();
            Agitavit.Utilities.openDeleteDialog(entityId, selectedRows, function () {
                form.control(control).reloadData();
                form.control(control).clearSelectedRows();
            });
        }
        SearchPage.removeEntries = removeEntries;
        function toolbarEnableOnSingleSelect(control, form) {
            var buttons = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                buttons[_i - 2] = arguments[_i];
            }
            // register on selection change handler
            form.control(control).onSelectionChanged.subscribe(function (_, args) {
                var selectedRows = args.length;
                buttons.forEach(function (btn) {
                    form.toolbar.enable(btn, selectedRows === 1);
                });
            });
            // set current status
            var selectedRows = form.control(control).getSelectedRows().length;
            buttons.forEach(function (btn) {
                form.toolbar.enable(btn, selectedRows === 1);
            });
        }
        SearchPage.toolbarEnableOnSingleSelect = toolbarEnableOnSingleSelect;
        function toolbarEnableOnSelect(control, form) {
            var buttons = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                buttons[_i - 2] = arguments[_i];
            }
            // register on selection change handler
            form.control(control).onSelectionChanged.subscribe(function (_, args) {
                var selectedRows = args.length;
                buttons.forEach(function (btn) {
                    form.toolbar.enable(btn, selectedRows >= 1);
                });
            });
            // set current status
            var selectedRows = form.control(control).getSelectedRows().length;
            buttons.forEach(function (btn) {
                form.toolbar.enable(btn, selectedRows >= 1);
            });
        }
        SearchPage.toolbarEnableOnSelect = toolbarEnableOnSelect;
        function editOnDoubleClick(control, form, type, entityId, formGroupId, parameters) {
            if (type === void 0) { type = "Dialog"; }
            if (entityId === void 0) { entityId = null; }
            form.control(control).onDoubleClick.subscribe(function () { return editEntry(control, form, type, entityId, formGroupId, parameters); });
        }
        SearchPage.editOnDoubleClick = editOnDoubleClick;
    })(SearchPage = Platform.SearchPage || (Platform.SearchPage = {}));
})(Platform || (Platform = {}));
//# sourceMappingURL=SearchPage.js.map